import * as React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";

// @mui
import {
  Card,
  Stack,
  Button,
  Box,
  Container,
  Typography,
  IconButton,
  Breadcrumbs,
  TextField,
} from "@mui/material";

// hooks
import useSettings from "../../hooks/useSettings";

// components
import Page from "../../components/Page";
import { useEffect } from "react";
import { useState } from "react";
import axios from "axios";

// ----------------------------------------------------------------------

export default function Patients_Doctor() {
  const [searchName, setSearchName] = useState("");
  const { themeStretch } = useSettings();
  const [rows, setRows] = useState([]);
  const navigate = useNavigate();
  // const handleEdit = (id) => {
  //   navigate("/dashboard/mypatients/edit", { state: { id } });
  //   // //console.log(id);
  // };
  const handleView = (id) => {
    navigate("/dashboard/mypatients/view", { state: { id } });
  };

  // const actionBtn = (id) =>{
  //   return <Stack direction="row" alignItems="center" spacing={1}>
  //   {/* <Link to={`/dashboard/mypatients/view/${id}`} >
  //   <IconButton aria-label="add" size="medium">
  //       <VisibilityIcon fontSize="inherit" />
  //   </IconButton>
  //   </Link> */}
  //   <IconButton aria-label="edit" size="medium" onClick={() => handleEdit(id)}>
  //           <EditIcon fontSize="inherit" />
  //   </IconButton>
  // {/* <Link to={`/dashboard/mypatients/edit/${id}`} >
  //   <IconButton aria-label="edit" size="medium">
  //       <EditIcon fontSize="inherit" />
  //   </IconButton>
  // </Link>   */}
  //   </Stack>
  // };

  const actionBtn = (id) => {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        <IconButton
          aria-label="add"
          size="medium"
          onClick={() => handleView(id)}
        >
          <VisibilityIcon fontSize="inherit" />
        </IconButton>
        {/* <IconButton
          aria-label="edit"
          size="medium"
          onClick={() => handleEdit(id)}
        >
          <EditIcon fontSize="inherit" />
        </IconButton> */}
        {/* <IconButton aria-label="delete" size="meduim">
          <DeleteIcon fontSize="inherit" />
        </IconButton> */}
      </Stack>
    );
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 80,
      // renderCell: (index) =>
      // String(index.api.getRowIndexRelativeToVisibleRows(index.row.id) + 1),
    },
    {
      field: "firstname",
      headerName: "First Name",
      width: 140,
    },
    // {
    //   field: 'middlename',
    //   headerName: 'Middle Name',
    //   width: 150,
    // },
    {
      field: "lastname",
      headerName: "Lastname",
      width: 140,
    },
    {
      field: "mobile",
      headerName: "Contact",
      width: 140,
    },

    {
      field: "email",
      headerName: "Email",
      width: 260,
    },
    {
      field: "dob",
      headerName: "Date Of Birth",
      width: 160,
    },

    {
      field: "gender",
      headerName: "Gender",
      width: 100,
      valueGetter: (params) => {
        if (params.value == "M" || params.value == "1") {
          return "Male";
        } else if (params.value == "F" || params.value == "2") {
          return "Female";
        } else if (params.value == "O" || params.value == "3") {
          return "Other";
        } else {
          return " ";
        }
      },
    },
    {
      field: "actions",
      headerName: "Actions",
      width: 160,
      // renderCell: (params) => {
      //   let id = params.row.id
      //      return (
      //              <actionBtn {...{params, id}}/>
      //      );
      //   }
      renderCell: (params) => {
        let id = params.row.id;
        return actionBtn(id);
      },
    },
    {
      field: "date_of_joining",
      width: 180,
    },
  ];

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_KAIZEN_API}/api/dev3/patients`)
      .then(function (response) {
        //console.log(response);
        console.log("");
        const data = response.data;
        setRows(data);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title> Patients| Kaizen Digital </title>
      </Helmet>
      <Page title="Page Two">
        <Container maxWidth={themeStretch ? false : "xl"}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Stack direction="column" spacing={0}>
              <Typography variant="h3" gutterBottom color="primary">
                Patients
              </Typography>
              <div role="presentation">
                <Breadcrumbs aria-label="breadcrumb">
                  <Typography
                    sx={{ display: "flex", alignItems: "center" }}
                    color="text.primary"
                  >
                    Dashboard
                  </Typography>

                  <Typography
                    sx={{ display: "flex", alignItems: "center" }}
                    color="text.primary"
                  >
                    Patients
                  </Typography>
                </Breadcrumbs>
              </div>
            </Stack>
            <Stack direction="row" spacing={2}>
              {/* <Link to="/dashboard/mypatients/patientsmainstepper" >
          <Button variant="contained" spacing={2} style={{textDecoration:"none"}} >
            New Patient
          </Button>
          </Link> */}
              {/* <Link to="/dashboard/myprofile/editinfo">
          <Button variant="contained" spacing={2} style={{textDecoration:"none"}} >
            Edit Patient
          </Button>
          </Link>
          <Link to="/dashboard/patientprofile">
          <Button variant="contained" spacing={2} style={{textDecoration:"none"}} >
            View 
          </Button>
          </Link> */}
            </Stack>
          </Stack>

          <Card>
            <Box sx={{ width: "100%" }}>
              <TextField
                label="Search by Name"
                variant="outlined"
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
                margin="normal"
                sx={{ marginLeft: "2%" }}
              />
              <br /> <br />
              <DataGrid
                autoHeight
                slots={{ toolbar: GridToolbar }}
                componentsProps={{
                  toolbar: {
                    csvOptions: { disableToolbarButton: true },
                    printOptions: { disableToolbarButton: true },
                  },
                }}
                // rows={rows}
                rows={rows.filter(
                  (row) =>
                    row.lastname
                      .toString()
                      .toLowerCase()
                      .includes(searchName.toString().toLowerCase()) ||
                    row.firstname
                      .toString()
                      .toLowerCase()
                      .includes(searchName.toString().toLowerCase())
                )}
                columns={columns}
                initialState={{
                  pagination: {
                    paginationModel: {
                      pageSize: 5,
                    },
                  },
                  sorting: {
                    sortModel: [{ field: "date_of_joining", sort: "desc" }],
                  },
                }}
                pageSizeOptions={[5, 10, 25]}
                // checkboxSelection
                disableRowSelectionOnClick
                loading={!rows.length}
              />
            </Box>
          </Card>
        </Container>
      </Page>
    </>
  );
}
